import { Component, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { RequestService } from '@api/request.service';
import jalaliMoment = require('jalali-moment');
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-request-list',
  templateUrl: './request-list.component.html',
  styleUrls: ['./request-list.component.scss']
})
export class RequestListComponent implements OnInit {
  startPage = 1;
  pageSize = 100;
  total = 0;
  filter;
  public destroy$ = new Subject<void>();
  requestList: any;
  serviceType = [
    { labelFa: 'حمل و نقل', labelEn: 'Transportation', values: 0 },
    { labelFa: 'ترخیص', labelEn: 'Clearance', values: 1 },
    { labelFa: 'حمل و نقل و ترخیص', labelEn: 'Clearance and Transportation', values: 2 },
    { labelFa: 'همه', labelEn: 'Clearance and Transportation', values: undefined },
  ];
  constructor(
    private requestService: RequestService
  ) { }

  ngOnInit(): void {
    this.getRequestListCustomer();
  }

  changeServiceType(serviceType) {
    if (serviceType?.value === 0) {
      this.filter = 0;
    } else if (serviceType?.value === 1) {
      this.filter = 1;
    } else if (serviceType?.value === 2) {
      this.filter = 2;
    }
    else if (serviceType?.value === undefined) {
      this.filter = undefined;
    }
    this.getRequestListCustomer();
  }

  getRequestListCustomer() {
    this.requestService.getRequestList(this.startPage, this.pageSize, this.filter).pipe(takeUntil(this.destroy$)).subscribe(
      (res: any) => {
        this.requestList = res;
        this.requestList?.requestList.forEach((element): any => {
          element.createdAt = jalaliMoment(element.createdAt).format('jYYYY/jMM/jDD hh:mm');
        });
      }
    )
  }

  public getServerData(event?: PageEvent) {
    this.pageSize = event.pageSize
    this.requestService.getRequestList((event.pageIndex) + 1, this.pageSize, this.filter).pipe(takeUntil(this.destroy$)).subscribe(
      (res) => {
        this.requestList = res;
        this.requestList?.requestList.forEach((element): any => {
          element.createdAt = jalaliMoment(element.createdAt).format('jYYYY/jMM/jDD hh:mm');
        });
      }
    )
  }
}
